import { render, staticRenderFns } from "./Shield.vue?vue&type=template&id=c085c42e&"
import script from "./Shield.vue?vue&type=script&lang=ts&"
export * from "./Shield.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports